// extracted by mini-css-extract-plugin
export default {"FlagDanger":"flag_FlagDanger__jy+zn","FlagNormal":"flag_FlagNormal__gffVd"};